import * as angular from "angular";
import {IController} from "angular";
import {AnalyticsService} from "../../services/analytics-service.service";

export class BringozToastComponent implements IController {
  type: any;
  details: any;
  body: any;
  message: any;
  action: any;
  replaceObject: any;

  icon: any;

  constructor(private $mdToast, private analyticsService: AnalyticsService) {
  }

  $onInit() {
    this.icon =
      this.type === 'success' ?
        '/assets/images/icons/toast-success-icon.png' :
        '/assets/images/icons/toast-error-icon.png';
  }

  onClose() {
    // this.analyticsService.trackException('close-toast', false);
    this.$mdToast.hide()
  }

  onAction(event) {
    this.$mdToast.hide(true)
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozToast', {
    bindings: {
      type: '<',
      details: '<',
      body: '<?',
      message: '<?',
      action: '<?',
      replaceObject: '<?'
    },
    templateUrl: 'app/modules/commons/components/bringoz-toast/bringoz-toast.html',
    controller: BringozToastComponent
  });

